import { EncryptStorage } from 'encrypt-storage';

export const ENCRYPTED_HASH = 'k6GAdP*UkDF*%$$Q2r7muFaSv#nUOgysHO@$qSjz1gz&sxtwpbJ0*CQrGxg';

export const encryptedLocalStorage = new EncryptStorage(ENCRYPTED_HASH, {
  prefix: '@portal_uy1',
  storageType: 'localStorage',
});
